module.exports = __webpack_public_path__ + "img/42.083cc713.jpg";